// ═══ 대행사 거래처 고르기 (W1a ①·②) — 신청 ① 차마다 '거래처' 한 줄 + 고르기 시트 ═══
// 시트: 검색 · 본인 맨 위 → 최근 신청 순(requestLogic.sortPickClients) · '최근' 배지 1곳 · 수거 주소 저장 여부 ·
// '+ 새 거래처 추가'(대표만 — 호출측 canAdd) → NewClientSheet · '아직 고르지 않은 차에도 같이 넣기'(기본 켬).
// 행을 누르면 고르고 닫힌다 — 실제 반영(차별 거래처·묶음 수거 주소 기본값)은 호출측 onPick.
import React, { useState } from 'react';
import { T, R, FONT } from '../../theme';
import { SheetFrame } from '../../simple/parts/ConfirmSheet';
import { input as inputSt } from '../../simple/screens/request/bits';
import { pickedClient, recentClientId, shortAddr, sortPickClients } from '../requestLogic';
import NewClientSheet from './NewClientSheet';

var rowsBox = { display: 'flex', flexDirection: 'column', gap: 8 };
var head = { fontSize: 13, fontWeight: 700, color: T.navy };
var unitRow = { display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 10, padding: '10px 12px', background: T.card,
  border: '1px solid ' + T.bd, borderRadius: R.card };
var carSt = { flex: '1 1 140px', minWidth: 0, fontSize: 13.5, fontWeight: 800, color: T.ink, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
var labSt = { flex: 'none', fontSize: FONT.label, fontWeight: 700, color: T.muted };
var pickBtn = { flex: '1 1 160px', minWidth: 0, display: 'flex', alignItems: 'center', gap: 6, height: 36, padding: '0 10px', borderRadius: R.md,
  border: '1.5px solid ' + T.accentBd, background: T.accentTint, color: T.accentPress, fontSize: 13, fontWeight: 700, fontFamily: 'inherit',
  cursor: 'pointer', textAlign: 'start' };
var pickNeed = Object.assign({}, pickBtn, { border: '1.5px solid ' + T.warnBd, background: T.warnTint, color: T.warn });
var grow = { flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
var subSt = { margin: 0, fontSize: 12, color: T.muted, textAlign: 'start' };
var item = { display: 'flex', alignItems: 'center', gap: 12, width: '100%', padding: '11px 4px', border: 0, borderBottom: '1px solid ' + T.bdSoft,
  background: 'none', cursor: 'pointer', fontFamily: 'inherit', textAlign: 'start', color: T.ink };
var nm = { display: 'flex', alignItems: 'center', gap: 6, fontSize: 14, fontWeight: 700 };
var badge = { fontSize: FONT.badge, fontWeight: 700, padding: '2px 7px', borderRadius: R.pill, background: T.track, color: T.dim };
var sub = { display: 'block', fontSize: 12, color: T.muted, marginTop: 2 };
var radio = { flex: 'none', width: 18, height: 18, borderRadius: R.pill, border: '2px solid ' + T.line, boxSizing: 'border-box' };
var radioOn = Object.assign({}, radio, { border: '6px solid ' + T.accent });
var addBtn = { border: 0, background: 'none', padding: '10px 4px', textAlign: 'start', color: T.accent, fontSize: 14, fontWeight: 700,
  fontFamily: 'inherit', cursor: 'pointer' };
var chk = { display: 'flex', alignItems: 'center', gap: 10, padding: 12, borderRadius: R.lg, background: T.head, fontSize: 13, color: T.body, cursor: 'pointer' };

function str(v) { return String(v == null ? '' : v).trim(); }

/// 차 라벨 = 차량번호 — 아직 비었으면 칸 이름('차량번호').
export function carLabel(t, c) {
  return str(c.carNo) || t('malsoModeFieldCarNo');
}

/// 거래처 이름 — 본인 몫은 '{이름} (본인)'.
export function clientName(t, c) { return c.isSelf ? t('malsoModeBrokerSelfName', { name: c.name }) : c.name; }

/// ① 차마다 '거래처' 한 줄 — 미선택은 노란 버튼. props: { t, head, cards, unitOf, clients, onOpen(cardKey) }
export function UnitRows(props) {
  var t = props.t;
  return (<div style={rowsBox} data-testid="malso-unit-rows">
    <span style={head}>{props.head}</span>
    {props.cards.map(function (c) {
      var client = pickedClient(props.clients, props.unitOf, c.key);
      return (<div key={c.key} style={unitRow} data-testid={'unit-row-' + c.key}>
        <span style={carSt}>{carLabel(t, c)}</span>
        <span style={labSt}>{t('malsoModeBrokerClients')}</span>
        <button type="button" style={client ? pickBtn : pickNeed} data-testid={'unit-pick-' + c.key} data-unit={client ? client.id : ''}
          onClick={function () { props.onOpen(c.key); }}>
          <span style={grow}>{client ? clientName(t, client) : t('malsoModeBrokerPickClient')}</span><span aria-hidden="true">▾</span>
        </button>
      </div>);
    })}
  </div>);
}

/// ② 고르기 시트. props: { t, card, clients, selectedId, canAdd, accountName, agencyName, onPick(client, applyUnpicked, isNew), onClose }
function UnitPickSheet(props) {
  var t = props.t;
  var stQ = useState(''); var q = stQ[0], setQ = stQ[1];
  var stApply = useState(true); var apply = stApply[0], setApply = stApply[1];
  var stAdding = useState(false); var adding = stAdding[0], setAdding = stAdding[1];
  if (adding) {
    return (<NewClientSheet accountName={props.accountName} agencyName={props.agencyName}
      onDone={function (c) { props.onPick(c, apply, true); }} onClose={function () { setAdding(false); }} />);
  }
  var recent = recentClientId(props.clients);
  var needle = q.trim().toLowerCase();
  var list = sortPickClients(props.clients).filter(function (c) { return !needle || String(c.name).toLowerCase().indexOf(needle) >= 0; });
  return (<SheetFrame open title={t('malsoModeBrokerPickClient')} onClose={props.onClose} closeLabel={t('actionClose')}>
    <p style={subSt}>{carLabel(t, props.card)}</p>
    <input style={inputSt} value={q} placeholder={t('malsoModeBrokerSearchHint')} aria-label={t('malsoModeBrokerSearchHint')}
      data-testid="unit-search" onChange={function (e) { setQ(e.target.value); }} />
    <div>{list.map(function (c) {
      var on = c.id === props.selectedId;
      return (<button key={c.id} type="button" style={item} data-client={c.id} aria-pressed={on} onClick={function () { props.onPick(c, apply, false); }}>
        <span style={grow}>
          <span style={nm}>{clientName(t, c)}{c.id === recent ? <span style={badge}>{t('malsoModeBrokerRecent')}</span> : null}</span>
          <span style={sub}>{c.isSelf ? t('malsoModeBrokerSelfSub')
            : c.pickupAddress ? t('malsoModeBrokerPickupSaved', { place: shortAddr(c.pickupAddress) }) : t('malsoModeBrokerPickupNone')}</span>
        </span>
        <span style={on ? radioOn : radio} />
      </button>);
    })}</div>
    {props.canAdd ? (<button type="button" style={addBtn} data-testid="unit-add" onClick={function () { setAdding(true); }}>
      {'+ ' + t('malsoModeBrokerAddNew')}</button>) : null}
    <label style={chk}>
      <input type="checkbox" checked={apply} data-testid="unit-apply" onChange={function (e) { setApply(e.target.checked); }} />
      <span>{t('malsoModeBrokerApplyUnpicked')}</span>
    </label>
  </SheetFrame>);
}

export default UnitPickSheet;
